export default __webpack_public_path__ + "static/media/purpleTcgPowertools.815e9cc3.png";